import React, { useEffect, useState, useRef } from "react";
import { observer } from "mobx-react";
import { useStore } from "../../../stores";
import PreviewBrief from "../BriefPreview";
import { formatDate } from "../../../utils/sharedFunctions.js";
import { Filter } from "../../../assets";
import { useServerFilter } from "../../../hooks/useServerFilter";
import { FilterRefined,PaginationControls, SearchBar } from "../../../components";
import "./style.scss";

const SearchIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/SearchIcon.svg`;
const Credipple = `${process.env.REACT_APP_CDN_URL}/globalAssets/CredippleLogo.svg`;
const UserIcon = `${process.env.REACT_APP_CDN_URL}/globalAssets/people.png`;

const mobile = require("is-mobile");

const Overview = observer(() => {
  const { projectStore, uiStore, authStore } = useStore();
  const [Projects, setProjects] = useState([]);
  const [FilteredProjects, setFilteredProjects] = useState([]);
  const [ViewProject, setViewProject] = useState(false);
  const [SelectedProject, setSelectedProject] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [isFilter, setIsFilter] = useState(false);
  const [isFilterCleared, setIsFilterCleared] = useState(true);
  const [FilterTerms, setFilterTerms] = useState([]);
  const [AllUsers, setAllUsers] = useState([]);
  const [Leads, setLeads] = useState([]);
  const [Professionals, setProfessionals] = useState([]);
  const [Pagination, setPagination] = useState({ 
    currentPage :  1, 
    hasMore     : false, 
    nextCursor  : "", 
    prevCursor  : "",
    pageSize    : 8, 
    totalPages  : 0, 
    totalUsers  : 0
  })
  const isFirstRender = useRef(true);
  const { serverFilterProject } = useServerFilter({ projectStore, uiStore, setAvailBriefs:setFilteredProjects, setPagination, setYearSelected:"", searchTerm });

  const isInitialMount = useRef(true);

  useEffect(()=>{
        if (isFirstRender.current) {
            isFirstRender.current = false; 
        
            return; 
        }else{
            if(searchTerm !== ""){
                serverFilterProject("", searchTerm, "", "");
            }else{
              fetchProjects("", "");
            };
        };
  }, [searchTerm]);
  useEffect(() => {
    // extendSession()
    if (isInitialMount.current) {
      isInitialMount.current = false;
      fetchProjects("", "");
    }
  }, []);

  //#region functions
  const fetchProjects = async (lastId, navId) => {
    uiStore.setLoading(true);
    try {
      const projectsData = await projectStore.getProjects(lastId, navId);
      setProjects(projectsData?.projects || []);
      setFilteredProjects(projectsData?.projects || []);
      setPagination({
          currentPage :  projectsData?.currentPage ?? 1,
          hasMore     :  projectsData?.hasMore ?? false,
          nextCursor  :  projectsData?.nextCursor ?? "",
          prevCursor  :  projectsData?.prevCursor ?? "",
          pageSize    :  projectsData?.pageSize ?? 8,
          totalPages  :  projectsData?.totalPages ?? 0,
          totalItems  :  projectsData?.totalBriefs ?? 0
      });
    } catch (e) {
      console.error("Error fetching projects:", e);
    } finally {
      uiStore.setLoading(false);
    }
  };
  const handlePageChange = (e) => {
        const ID  = e;
        if (ID === 'next' && Pagination.hasMore) {
            fetchProjects(Pagination.nextCursor, 'lastId');
        }else{
            if (Pagination.currentPage > 1) {
                fetchProjects(Pagination.prevCursor,'prevId');
            }
        }
  };
  const backClicked = (back, isEdited) => {
    if (isEdited) fetchProjects();
    setViewProject(back);
  };

  const getSelectedProject = (id) => {
    const projects = isFilterCleared && searchTerm ==='' ? Projects : FilteredProjects;
    const selected = projects.find((proj) => proj._id === id);
    if (selected) setSelectedProject(selected);
   setViewProject(true);
  };

  const handleSearchChange = (value) => {
    setSearchTerm(value);
  };

  const handleFilterClick = () => setIsFilter(true);
  const closeFilterMouseleave = () => setIsFilter(false);
  const closeCardClick = () => {
    setIsFilterCleared(true);
    closeFilterMouseleave();
    setFilterTerms([]);
    setFilteredProjects([...Projects]);
  };

  const handleFilterChange = (items) => {
    if (!items || items.length === 0) return closeCardClick();

    const filteredProjs = Projects.filter((project) =>
      items.some(
        (item) =>
          (Array.isArray(project.typeOfProfessional) &&
            project.typeOfProfessional.includes(item)) ||
          item === project.contractType ||
          item === project.projectPlan?.[0]?.fulfillmentStage ||
          item === project.briefStatus ||
          item === project._id
      )
    );

    setFilteredProjects(filteredProjs);
    setFilterTerms([...items]);
    setIsFilterCleared(false);
  };
  //#endregion

  if (mobile()) return <div></div>;

  return (
    <div className="OverviewPage">
      <div className="OverviewPageHeader">
        <p>Overview</p>
        <img src={Credipple} alt="Credipple Logo" />
      </div>

      {ViewProject ? (
        <div style={{ width: "100%", height: "88%" }}>
          <PreviewBrief
            project={SelectedProject}
            AllUsers={AllUsers}
            navigateMainToPage={backClicked}
            professionals={Professionals}
            Briefs={Projects}
            setBriefs={setProjects}
            leads={Leads}
          />
        </div>
      ) : (
        <>
          <div className="filterBriefsSection">
            <div className="search-bar-section" style={{ backgroundColor: "#fff", width: "25%", height: "50%" }}>
             <SearchBar
              value={searchTerm}
              onSearch={(e)=>handleSearchChange(e)}
              placeholder='Search'
              debounceDelay={1000}
              disabled={false}
              className=''
              searchIconUrl={SearchIcon}
              style={{ width: '100%', backgroundColor: '#fff' }}
              />
            </div>

            <div
              onMouseEnter={handleFilterClick}
              className={FilterTerms.length === 0 ? "filterContainer" : "filterContainerAct"}
            >
              <span className="filterspan">
                <img src={Filter} alt="" className="filterimg" />
              </span>
              {FilterTerms.length > 0 && (
                <p style={{ color: "white", paddingLeft: "5%" }}>Filters({FilterTerms.length})</p>
              )}
            </div>

            <div className="numofItems">
              <PaginationControls
                styles={{width: 'fit-content'}}
                currentPage={Pagination.currentPage}
                totalPages={Pagination.totalPages}
                onPageChange={handlePageChange}
                hasMore={Pagination.hasMore}    
              />
              {/* <p className="spancular">{FilteredProjects.length}</p> */}
            </div>
          </div>

          <div className="OverviewPageBody">
            {isFilter && (
              <FilterRefined
                Projects={FilteredProjects.length === 0 ? Projects : FilteredProjects}
                Leads={Leads}
                getFilterTerm={() => {}}
                terms={FilterTerms}
                handleFilterChange={handleFilterChange}
                CloseFilterML={closeFilterMouseleave}
                CloseCardClck={closeCardClick}
              />
            )}

            {FilteredProjects.length > 0 &&
              FilteredProjects.map((item, index) => {
                const clientName =
                  item?.client?.firstName && item?.client?.lastName
                    ? `${item.client.firstName} ${item.client.lastName}`
                    : item?.client?.company || "Not Assigned";
                const clientComp = item?.client?.email || item?.client?.website || "Not Assigned";
                const fulfillmentName =
                  item.fullfilmentLead && typeof item.fullfilmentLead !== "string"
                    ? `${item.fullfilmentLead.firstName} ${item.fullfilmentLead.lastName}`
                    : "Not Assigned";

                return (
                  <div className="availableBriefCard" key={index} onClick={() => getSelectedProject(item._id)}  >
                    <div className="availableBriefCardHeader">
                      <p style={{ margin: 0 }}>{item.title}</p>
                    </div>
                    <div className="availableBriefBody">
                      <div className="profileSection">
                        <div className="profileContainer">
                          <div className="userProfile">
                            <img alt="" src={UserIcon} style={{ width: "100%", height: "100%" }} />
                          </div>
                          <div className="clientDetails">
                            <p className="sectPlaceHolder">{clientName}</p>
                            <p className="sectValue">
                              {clientComp.length > 20 ? `${clientComp.substring(0, 20)}...` : clientComp}
                            </p>
                          </div>
                        </div>

                        <div className="otherMetricsSection">
                          <p className="sectPlaceHolder">Start Date</p>
                          <p className="sectValue">{formatDate(item?.startDate) || "No Date"}</p>
                        </div>
                      </div>

                      <div className="profileSection">
                        <div className="otherMetricsSection">
                          <p className="sectPlaceHolder">Category of service</p>
                          <p className="sectValue">{item?.serviceCategory?.[0] || "Not Assigned"}</p>
                        </div>
                        <div className="otherMetricsSection">
                          <p className="sectPlaceHolder">Fulfillment Lead</p>
                          <p className="sectValue">{fulfillmentName}</p>
                        </div>
                      </div>

                      <div className="profileSection">
                        <div className="otherMetricsSection">
                          <p className="sectPlaceHolder">Professionals</p>
                          <div className="availProfessionals">
                            <div className="userProfile">
                              <img alt="" src={UserIcon} style={{ width: "100%", height: "100%" }} />
                            </div>
                            <span>{item?.professional?.firstName??"" + " " + item?.professional?.lastName??""}</span>
                          </div>
                        </div>
                        <div className="otherMetricsSection">
                          <p className="sectPlaceHolder">Fulfillment Stage</p>
                          <p className="sectValue">{item?.brief?.projectPlan?.[0]?.fulfillmentStage || "Not Assigned"}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
          </div>
        </>
      )}
    </div>
  );
});

export default Overview;
